import { twMerge } from "tailwind-merge";
import { Card, CardContent, CardHeader, H5 } from "@sellar-io/components";
import { ReactElement } from "react";
import { SpinnerLegacy } from "../../../components";
import { usePaymentMethodList } from "../../../hooks/api/v2/paymentMethod/usePaymentMethodList";
import { PaymentMethodListItem } from "./PaymentMethodListItem";

export function BuyerPaymentPreferencePaymentMethods(): ReactElement {
  const paymentMethodsListQuery = usePaymentMethodList({});
  return (
    <Card className="bg-white">
      <CardHeader className={twMerge("bg-white", "p-4")}>
        <H5>Payment cards</H5>
        <p>
          When you use a payment card to place an upfront pro-forma order, its
          details are stored for future use by the supplier you placed the order
          with.
        </p>
      </CardHeader>
      <CardContent className={"p-4"}>
        {paymentMethodsListQuery.isPending ? (
          <SpinnerLegacy />
        ) : (
          <>
            {paymentMethodsListQuery.data?.pages.map((page) =>
              page.map((paymentMethod, i) => (
                <PaymentMethodListItem key={i} paymentMethod={paymentMethod} />
              )),
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
